"use client";

import { useTranslations } from "next-intl";
import { useState } from "react";

import PhoneNumberModal from "@/components/common/modals/PhoneNumberModal";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { initiateCallUs } from "@/lib/analytics/openai-events";

interface CallUsButtonProps {
  phone: string;
}

const CallUsButton = ({ phone }: CallUsButtonProps) => {
  const t = useTranslations("Contact.showroom");
  const [isPhoneNumberModalOpen, setIsPhoneNumberModalOpen] = useState(false);
  const isTabletOrLarger = useMediaQuery("(min-width: 768px)");

  const handleCallUsClick = () => {
    initiateCallUs({
      phone,
      isDesktop: isTabletOrLarger,
      onOpenModal: () => setIsPhoneNumberModalOpen(true),
      source: "contact_us_call_button",
    });
  };

  return (
    <>
      <button
        className="inter w-full rounded-xl bg-primary py-4 text-center font-medium text-white transition-all duration-300 hover:bg-primary-dark"
        onClick={handleCallUsClick}
        aria-label={t("callUs")}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleCallUsClick();
          }
        }}
      >
        {t("callUs")}
      </button>
      <PhoneNumberModal
        isOpen={isPhoneNumberModalOpen}
        onClose={() => setIsPhoneNumberModalOpen(false)}
        phoneNumber={phone}
        trackingSource="contact_us_call_button"
      />
    </>
  );
};

export default CallUsButton;
